import { AfterViewInit, Component, ElementRef, HostBinding, Input, OnChanges } from "@angular/core";
import { DelayedHoverService } from "@app/directives/_misc/delayed-hover.service";

import { RouteVisitStatus } from "@tms/_enums/RouteVisitStatus";
import { ActiveRoutesService, IRouteDetailDisplay, IRouteDetailVisitDisplay } from "@tms/_services/active-routes.service";
import "./active-route-visit.component.scss";

@Component({
    selector: "active-route-visit",
    template: require("./active-route-visit.component.html"),
    providers: [DelayedHoverService]
})
export class ActiveRouteVisitComponent implements OnChanges, AfterViewInit {

    @Input() visit: IRouteDetailVisitDisplay;
    @Input() plannedRoute: IRouteDetailDisplay;

    // ---

    @HostBinding("class") class: string;

    // ---

    visitIndex = 0;
    first = false;
    last = false;

    showPopup = false;
    visitIcon: string;
    minWidth = 40;

    statusString = "";

    constructor(
        private readonly elementRef: ElementRef,
        private readonly activeRoutesService: ActiveRoutesService,
        private readonly delayedHoverService: DelayedHoverService) {
    }

    ngOnChanges() {
        this.visitIndex = this.plannedRoute.displayPlannedVisits.indexOf(this.visit);
        this.first = this.visitIndex == 0;
        this.last = this.visitIndex == this.plannedRoute.displayPlannedVisits.length - 1;

        this.class = this.activeRoutesService.getVisitClass(this.visit);

        this.updateDisplayLabelWidth();
        this.updateVisitIcon();

        this.statusString = RouteVisitStatus[this.visit.Status];
    }

    ngAfterViewInit() {

        this.delayedHoverService.createMouseEnterDelay(
            this.elementRef.nativeElement,
            show => {
                this.showPopup = show;
            },
            150);
    }

    // ---

    private updateDisplayLabelWidth() {
        this.minWidth = Math.max(30, this.visit.pixelsToNextStop + this.visit.pixelWidth - 20);

        if (this.last) {
            this.minWidth = 200;
        }
    }

    private updateVisitIcon() {
        this.visitIcon = "";

        if (this.first) {
            this.visitIcon = "schedule";
        }

        if (this.last) {
            this.visitIcon = "flag";
        }

        switch (this.visit.Status) {
            case RouteVisitStatus.Arrived:
            case RouteVisitStatus.Departed:
                this.visitIcon = "done";
                break;

            case RouteVisitStatus.Missed:
            case RouteVisitStatus.Cancelled:
                this.visitIcon = "clear";
                break;
        }
    }
}
